import { listingKeys } from "./buyerKeys";

/**
 * Listing agent research (D7–D18) query keys.
 *
 * <p>Under the LISTING prefix on purpose: the workspace's Start facts are the
 * listing's own (URL, agent, contact form), so any listing save — a Source-card
 * URL edit, an agent change — must refresh them, and invalidating
 * `listingKeys.all` already does. A research save invalidates both.</p>
 */
export const listingAgentResearchKeys = {
  all: [...listingKeys.all, "agent-research"] as const,
  forListing: (listingId: string) => [...listingAgentResearchKeys.all, listingId] as const,
  workspace: (listingId: string) => [...listingAgentResearchKeys.forListing(listingId), "workspace"] as const,
  summary: (listingId: string) => [...listingAgentResearchKeys.forListing(listingId), "summary"] as const,
  run: (listingId: string, runId: string) =>
    [...listingAgentResearchKeys.forListing(listingId), "run", runId] as const,
  /** ⑤'s preview: a POST that writes nothing, read as a query. */
  savePreview: (listingId: string, runId: string) =>
    [...listingAgentResearchKeys.forListing(listingId), "save-preview", runId] as const,
};
